module.exports = __webpack_public_path__ + "media/fail.fac8e2e8.mp3";